import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowCornerUpLeft: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-corner-up-left"><path d="M20.25 19V8.5H4.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M7.75 12.5L3.75 8.5L7.75 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowCornerUpLeft;
